module.exports = __webpack_public_path__ + "static/media/status.9efe7e70.svg";